{
  // the location thumbnails should stay in sync with real time showing open/close
  // however, if we rely on PHP for this, page caching will make it not work
  // so this script allows for PHP page caching but double checks open/closed-ness with JS to ensure it is always right

  const allThumbnails = document.querySelectorAll('.location-thumbnail[data-location-id]')
  
  if(allThumbnails.length){
    window.coolHelperFunctions.coolAjax({
      action: 'refresh_location_thumbnails',
      post_ids: Array.from(allThumbnails).map(el => el.getAttribute('data-location-id'))
    }, success => {
      if(success?.data?.refreshed_thumbnails?.length){
        success.data.refreshed_thumbnails.forEach(row => {
          const found = document.querySelectorAll(`.location-thumbnail[data-location-id="${row.post_id}"]`)
          if(found.length){
            found.forEach(el => el.outerHTML = row.block)
          }
        })
      }
    }, error => {
      // silent fail because this wasn't triggered by user interaction
    })
  }
}